{
  "name": "@supadata/js",
  "version": "1.3.2",
  "description": "TypeScript / JavaScript SDK for Supadata API",
  "homepage": "https://supadata.ai",
  "repository": "https://github.com/supadata-ai/js",
  "main": "./dist/index.cjs",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.mjs",
      "require": "./dist/index.cjs",
      "default": "./dist/index.mjs"
    }
  },
  "scripts": {
    "dev": "tsup --watch",
    "build": "tsup",
    "test": "node --experimental-vm-modules node_modules/jest/bin/jest.js",
    "prepare": "npm run build",
    "format": "prettier --write \"src/**/*.{js,ts}\"",
    "format:check": "prettier --check \"src/**/*.{js,ts}\""
  },
  "files": [
    "dist",
    "README.md"
  ],
  "keywords": [
    "supadata",
    "api",
    "sdk",
    "typescript",
    "youtube",
    "tiktok",
    "instagram",
    "twitter",
    "transcript",
    "web scraping"
  ],
  "author": "Supadata AI",
  "license": "MIT",
  "engines": {
    "node": ">=18"
  },
  "dependencies": {
    "cross-fetch": "^4.0.0"
  },
  "devDependencies": {
    "@types/jest": "^29.5.14",
    "@types/node": "^22.10.10",
    "jest": "^29.7.0",
    "jest-fetch-mock": "^3.0.3",
    "prettier": "^3.4.2",
    "ts-jest": "^29.2.5",
    "typescript": "^5.7.3",
    "tsup": "^8.3.6"
  }
}